import  { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { FaUser, FaCog } from "react-icons/fa";
import { MdLogout, MdOutlinePayment, MdTrackChanges } from "react-icons/md";
import "./Style/Profiledropdown.css";
import {
  getAuthToken,
  getUserName,
  removeAuthToken,
} from "../Localstorage/Localstorage";
import { useNavigate } from "react-router-dom";
import { usePostLogoutMutation, useUpdatePasswordMutation } from "../store/api/adminapi";

const Profiledropdown = () => {
  const token = getAuthToken();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [updatePassword, { isLoading, isError, error: apiError }] =
    useUpdatePasswordMutation();

  const toggle = () => setIsDropdownOpen(!isDropdownOpen);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const username = getUserName();
  const nvg = useNavigate();

  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage("All fields are required.");
      setMessageType("error");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("New password and confirm password do not match.");
      setMessageType("error");
      return;
    }
    try {
      const jsondata = {
        current_password: oldPassword,
        new_password: newPassword,
      };
      const response = await updatePassword(jsondata);
      console.log("Password updated successfully:", response);

      if (response.error) {
        setMessage(
          response.error.data?.message ||
            "Failed to update password. Please try again."
        );
        setMessageType("error");
      } else {
        setMessage(response.data.message);

        if (response.data.message === "Password updated") {
          setMessage("Password updated successfully!");
          setMessageType("success");

          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");

          setTimeout(() => {
            setMessage("");
            toggleModal();
          }, 1000);
        }
      }
    } catch (error) {
      console.error("Update Password Error:", error);
      setMessage("Something went wrong. Please try again.");
      setMessageType("error");
    }
  };
  const [logoutApi] = usePostLogoutMutation()
  const Logout = () => {

    const response = logoutApi({"api_key":token.api_key}); 
    removeAuthToken();
    localStorage.removeItem("pageHistory");
    nvg("/");
  };

  return (
    <>
      <Dropdown
        isOpen={isDropdownOpen}
        toggle={toggle}
        className="user-dropdown"
      >
        <DropdownToggle caret className="btn btn-primary">
          <FaUser className="user-icon" />
          
           {/* {username} */}
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem className="pb-1">
            <FaUser color="#0d6efd" fontSize={14} />{" "}
            <span style={{ color: "#0d6efd", fontSize: "13px" }}>
              {username}
            </span>
          </DropdownItem>
          <DropdownItem className="pb-1" onClick={toggleModal}>
            <MdTrackChanges color="#0d6efd" fontSize={14} />
            <span style={{ color: "#0d6efd", fontSize: "13px" }}>
              {" "}
              Change Password{" "}
            </span>
          </DropdownItem>
          <DropdownItem className="pb-1" onClick={()=>{nvg("/setting/")}}>
            <FaCog color="#0d6efd" fontSize={14} />
            <span style={{ color: "#0d6efd", fontSize: "13px" }} onClick={()=>{nvg("/setting/")}}>
              {" "}
              Settings
            </span>
          </DropdownItem>
          <DropdownItem className="pb-1">
            <MdOutlinePayment color="#0d6efd" fontSize={14} />{" "}
            <span style={{ color: "#0d6efd", fontSize: "13px" }}>
              {" "}
              Payment Info{" "}
            </span>
          </DropdownItem>
          <DropdownItem className="pb-1" onClick={Logout}>
            <MdLogout color="#0d6efd" fontSize={14} />{" "}
            <span style={{ color: "#0d6efd", fontSize: "13px" }}> Logout </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {/* Change Password */}
      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Change Password</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleUpdatePassword}>
            <FormGroup>
              <Label for="oldPassword">Old Password</Label>
              <Input
                type="password"
                id="oldPassword"
                name="current_password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Enter old password"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="newPassword">New Password</Label>
              <Input
                type="password"
                id="newPassword"
                name="new_password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="confirmPassword">Confirm New Password</Label>
              <Input
                type="password"
                id="confirmPassword"
                name="confirm_password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                required
              />
            </FormGroup>
            {message && (
              <p
                className={
                  messageType === "success" ? "text-success" : "text-danger"
                }
              >
                {message}
              </p>
            )}
            <ModalFooter>
              <Button
                type="button"
                onClick={handleUpdatePassword}
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Change Password"}
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Profiledropdown;
